import "./InsCreateSuccess.scss";
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import * as actions from "../../../../store/actions/createAccountAction";
import { login } from "../../../../api/helper";
import { Trans, withTranslation } from "react-i18next";

class InsCreateSuccess extends Component {
  static propTypes = {
    img: PropTypes.string.isRequired,
    text1: PropTypes.string.isRequired,
    text2: PropTypes.string,
    link: PropTypes.string.isRequired,
    textLink: PropTypes.string,
  };
  static defaultProps = {
    img: "",
    text1: "",
    link: "/",
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };
  }

  delInfos = () => {
    this.props.deleteInfos();
  };

  _connect = () => {
    const { history } = this.props;
    const { email, password } = this.props.userInfo.userInfo;
    this.setState({ loading: true });
    login(email, password, true)
      .then(() => {
        history.replace("/");
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  endCreateAccount = () => {
    this.delInfos();

    this.props.approuved ? this._connect() : this.props.history.replace("/");
  };

  render() {
    const { t, name, approved } = this.props;
    return (
      <>
        <div className="account-success">
          <div className={"account-logo " + this.props.img}></div>
          <div className="account-check-text">
            {approved ? (
              <Trans i18nKey="create_account_welcome">
                Welcome {name} Your account has been successfully created.
                <br />
                <br />
                Our team will verify your profile within the next 48 hours.
                <br />
                <br />
                If your profile is not approved, your account will be
                automatically deactivated.
              </Trans>
            ) : (
              <div>
                <p>{t("not_find_profile_moment")}</p>
                <p>{t("notified_mail_next_day_when_account_validated")}</p>
              </div>
            )}
          </div>
        </div>
        <div className="account-final-link">
          <button disabled={this.state.loading} onClick={this.endCreateAccount}>
            {this.props.textLink}
          </button>
        </div>
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  userInfo: state.createAccount,
});

const mapDispatchToProps = (dispatch) => {
  return {
    deleteInfos: () => {
      dispatch(actions.deleteInfos());
    },
  };
};

export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(InsCreateSuccess)
);
